/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveAutonomousVehicleAuthorityRequest } from '../models/ApproveAutonomousVehicleAuthorityRequest';
import type { AutonomousVehicle } from '../models/AutonomousVehicle';
import type { AutonomousVehicleContact } from '../models/AutonomousVehicleContact';
import type { AutonomousVehicleContactType } from '../models/AutonomousVehicleContactType';
import type { AutonomousVehicleDocumentType } from '../models/AutonomousVehicleDocumentType';
import type { CabCardRequest } from '../models/CabCardRequest';
import type { CertifyAutonomousVehicleAuthorityRegistrationRequest } from '../models/CertifyAutonomousVehicleAuthorityRegistrationRequest';
import type { CreateAutonomousVehicleAuthorityContactRequest } from '../models/CreateAutonomousVehicleAuthorityContactRequest';
import type { CreateAutonomousVehicleAuthorityRegistrationRequest } from '../models/CreateAutonomousVehicleAuthorityRegistrationRequest';
import type { CreateAutonomousVehicleAuthorityRegistrationResponse } from '../models/CreateAutonomousVehicleAuthorityRegistrationResponse';
import type { CreateAutonomousVehicleAuthorityRegistrationUsdotRequest } from '../models/CreateAutonomousVehicleAuthorityRegistrationUsdotRequest';
import type { CreateAutonomousVehicleAuthorityRegistrationUsdotResponse } from '../models/CreateAutonomousVehicleAuthorityRegistrationUsdotResponse';
import type { CreateAutonomousVehicleRequest } from '../models/CreateAutonomousVehicleRequest';
import type { GetHistoryResponse } from '../models/GetHistoryResponse';
import type { GetRegistrationResponse } from '../models/GetRegistrationResponse';
import type { ListContactsResponse } from '../models/ListContactsResponse';
import type { RejectAutonomousVehicleAuthorityRequest } from '../models/RejectAutonomousVehicleAuthorityRequest';
import type { StoredDocument } from '../models/StoredDocument';
import type { UpdateAutonomousVehicleAuthorityContactRequest } from '../models/UpdateAutonomousVehicleAuthorityContactRequest';
import type { UpdateAutonomousVehicleAuthorityRequest } from '../models/UpdateAutonomousVehicleAuthorityRequest';
import type { UpdateAutonomousVehicleRequest } from '../models/UpdateAutonomousVehicleRequest';
import type { VehicleBulkImportStatusResponse } from '../models/VehicleBulkImportStatusResponse';
import type { VehicleVinCheckResult } from '../models/VehicleVinCheckResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutonomousVehicleAuthorityService {
  /**
   * Get the autonomous vehicle authority registration for this user. Returns 404 if none exists.
   * @param registrationId
   * @returns GetRegistrationResponse OK
   * @throws ApiError
   */
  public static getRegistration(
    registrationId: string,
  ): CancelablePromise<GetRegistrationResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update one or more fields for an autonomous vehicle authority application. This can only be done after the application has been certified.
   * @param registrationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static update(
    registrationId: string,
    requestBody?: UpdateAutonomousVehicleAuthorityRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get the change history for an AV registration by its id. Returns JSON by default, or CSV/PDF when format is specified.
   * @param registrationId
   * @returns GetHistoryResponse OK
   * @throws ApiError
   */
  public static getHistory(
    registrationId: string,
  ): CancelablePromise<GetHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/history',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Create a new autonomous vehicle authority application using a USDOT number and EIN.
   * @param requestBody
   * @returns CreateAutonomousVehicleAuthorityRegistrationUsdotResponse OK
   * @throws ApiError
   */
  public static createFromUsdot(
    requestBody?: CreateAutonomousVehicleAuthorityRegistrationUsdotRequest,
  ): CancelablePromise<CreateAutonomousVehicleAuthorityRegistrationUsdotResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations/usdot',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Create a new autonomous vehicle authority application for a non-USDOT business entity.
   * @param requestBody
   * @returns CreateAutonomousVehicleAuthorityRegistrationResponse Created
   * @throws ApiError
   */
  public static create(
    requestBody?: CreateAutonomousVehicleAuthorityRegistrationRequest,
  ): CancelablePromise<CreateAutonomousVehicleAuthorityRegistrationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Certify an autonomous vehicle authority application with the certifier's title. The authorized user is recorded as the certifier, along with today's date. This also submits the application.
   * @param registrationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static certify(
    registrationId: string,
    requestBody?: CertifyAutonomousVehicleAuthorityRegistrationRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/certify',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Submit an autonomous vehicle authority application for review. This can only be done after the application has been certified.
   * @param registrationId
   * @returns void
   * @throws ApiError
   */
  public static submit(
    registrationId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/submit',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Purge an autonomous vehicle authority application. This can only be done while the application has a status of draft.
   * @param registrationId
   * @returns void
   * @throws ApiError
   */
  public static purge(
    registrationId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/purge',
      path: {
        'registrationId': registrationId,
      },
    });
  }
  /**
   * Approve an autonomous vehicle authority application for review. This can only be done after the application has been certified.
   * @param registrationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static approve(
    registrationId: string,
    requestBody?: ApproveAutonomousVehicleAuthorityRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/approve',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Reject an autonomous vehicle authority application for review. This can only be done after the application has been certified.
   * @param registrationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static reject(
    registrationId: string,
    requestBody?: RejectAutonomousVehicleAuthorityRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/reject',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Create a new contact for a given autonomous vehicle authority registration
   * @param registrationId
   * @param requestBody
   * @returns AutonomousVehicleContact Created
   * @throws ApiError
   */
  public static createContact(
    registrationId: string,
    requestBody?: CreateAutonomousVehicleAuthorityContactRequest,
  ): CancelablePromise<AutonomousVehicleContact> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/contacts',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * List contacts for a given autonomous vehicle authority registration
   * @param registrationId
   * @returns ListContactsResponse OK
   * @throws ApiError
   */
  public static listContacts(
    registrationId: string,
  ): CancelablePromise<ListContactsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/contacts',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a specific contact by registration ID and type
   * @param registrationId
   * @param type
   * @returns AutonomousVehicleContact OK
   * @throws ApiError
   */
  public static getContact(
    registrationId: string,
    type: AutonomousVehicleContactType,
  ): CancelablePromise<AutonomousVehicleContact> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/contacts/{type}',
      path: {
        'registrationId': registrationId,
        'type': type,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update a specific contact by registration ID and type
   * @param registrationId
   * @param type
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateContact(
    registrationId: string,
    type: AutonomousVehicleContactType,
    requestBody?: UpdateAutonomousVehicleAuthorityContactRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/contacts/{type}',
      path: {
        'registrationId': registrationId,
        'type': type,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * --- THIS SHOULD ONLY BE CALLED AFTER CALLING CreateVehicleWithVinCheck ---
   * Create a new vehicle and assign it to a given autonomous vehicle authority registration"
   * @param registrationId
   * @param requestBody
   * @returns AutonomousVehicle Created
   * @throws ApiError
   */
  public static createVehicle(
    registrationId: string,
    requestBody?: CreateAutonomousVehicleRequest,
  ): CancelablePromise<AutonomousVehicle> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/vehicles',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * List vehicles associated with an autonomous vehicle authority registration
   * @param registrationId
   * @returns AutonomousVehicle OK
   * @throws ApiError
   */
  public static listVehicles(
    registrationId: string,
  ): CancelablePromise<Array<AutonomousVehicle>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/vehicles',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Check for existing vehicle
   * If vehicle doesn't exist create a new vehicle and assign it to a given autonomous vehicle authority registration
   * If vehicle exists for the passed in registration ID pass back an error
   * If vehicle exists for another registration ID pass back a warning to allow user prompt
   * @param registrationId
   * @param requestBody
   * @returns AutonomousVehicle Created
   * @returns VehicleVinCheckResult Accepted
   * @throws ApiError
   */
  public static createVehicleWithVinCheck(
    registrationId: string,
    requestBody?: CreateAutonomousVehicleRequest,
  ): CancelablePromise<AutonomousVehicle | VehicleVinCheckResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/vehicles/vin',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Upload a CSV to bulk create/update vehicles (by VIN) for an autonomous vehicle authority registration. Processed asynchronously in the background; poll GetVehicleBulkImportStatus for progress.
   * @param registrationId
   * @param formData
   * @returns VehicleBulkImportStatusResponse Accepted
   * @throws ApiError
   */
  public static bulkUploadVehicles(
    registrationId: string,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/vehicles/bulk',
      path: {
        'registrationId': registrationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get the status of the most recent bulk vehicle CSV import for an autonomous vehicle authority registration.
   * @param registrationId
   * @returns VehicleBulkImportStatusResponse OK
   * @throws ApiError
   */
  public static getVehicleBulkImportStatus(
    registrationId: string,
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/vehicles/bulk/status',
      path: {
        'registrationId': registrationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get a specific vehicle by vehicle ID
   * @param vehicleId
   * @returns AutonomousVehicle OK
   * @throws ApiError
   */
  public static getVehicle(
    vehicleId: string,
  ): CancelablePromise<AutonomousVehicle> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/vehicles/{vehicleId}',
      path: {
        'vehicleId': vehicleId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Update a specific vehicle by vehicle ID
   * @param vehicleId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateVehicle(
    vehicleId: string,
    requestBody?: UpdateAutonomousVehicleRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/AutonomousVehicleAuthority/vehicles/{vehicleId}',
      path: {
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a specific vehicle by vehicle ID
   * @param vehicleId
   * @returns void
   * @throws ApiError
   */
  public static deleteVehicle(
    vehicleId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/AutonomousVehicleAuthority/vehicles/{vehicleId}',
      path: {
        'vehicleId': vehicleId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Gets authorization card PDFs
   * @param registrationId
   * @param requestBody
   * @returns binary OK
   * @throws ApiError
   */
  public static getAvAuthCards(
    registrationId: string,
    requestBody?: CabCardRequest,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/vehicles/{registrationId}/auth-card',
      path: {
        'registrationId': registrationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Upload an AV registration document to S3.
   * @param registrationId
   * @param documentType
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadAutonomousVehicleDocument(
    registrationId: string,
    documentType: AutonomousVehicleDocumentType,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/uploads/{documentType}',
      path: {
        'registrationId': registrationId,
        'documentType': documentType,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Get AV document metadata, if one exists, for a document type.
   * @param registrationId
   * @param documentType
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static getAutonomousVehicleDocument(
    registrationId: string,
    documentType: AutonomousVehicleDocumentType,
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/uploads/{documentType}',
      path: {
        'registrationId': registrationId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete an AV document for a document type.
   * @param registrationId
   * @param documentType
   * @returns void
   * @throws ApiError
   */
  public static deleteAutonomousVehicleDocument(
    registrationId: string,
    documentType: AutonomousVehicleDocumentType,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/uploads/{documentType}',
      path: {
        'registrationId': registrationId,
        'documentType': documentType,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stream an AV document for preview or download.
   * @param registrationId
   * @param documentType
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadAutonomousVehicleDocument(
    registrationId: string,
    documentType: AutonomousVehicleDocumentType,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/AutonomousVehicleAuthority/registrations/{registrationId}/uploads/{documentType}/content',
      path: {
        'registrationId': registrationId,
        'documentType': documentType,
      },
      query: {
        'download': download,
      },
    });
  }
}
